import React from 'react';
import Layout from '../components/shared/Layout';
import Header from '../components/shared/Header';
import ContactForm from '../components/contact/ContactForm';

const Contact = () => (
    <Layout title="Contact Us">
        <Header title="Contact Us" page="Contact"/>
        <ContactForm />
    </Layout>
)

export default Contact;